import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapCancellationStatusOptions = (
  attributes: UCM.CancellationStatusOptionRawType,
): UCM.CancellationStatusOptionType => ({
  value: attributes.id,
  label: attributes.code,
});

const getCancellationStatusOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.CancellationStatusOptionRawType>
  >(API.GET.cancellationStatusOptions);
  return data.data.map(({ attributes }) =>
    mapCancellationStatusOptions(attributes),
  );
};

export const useGetCancellationStatusOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CANCELLATION_STATUS_OPTIONS],
    queryFn: getCancellationStatusOptions,
    ...config,
  });
};
